import React, { useEffect, useState } from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';
import queryString from 'query-string';

import { isEmpty } from 'lodash';

import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';
import UserDetails from './UserDetails';
import { setPageTitle } from '../../../helpers/auth';

import * as ArchitectActions from '../../../actions/architectActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as CoreActions from '../../../actions/coreActions';
import * as jobActions from '../../../actions/jobActions';

import classes from './UserPage.module.css';

const UserPage = ({
    activeNavCompany,
    companyInfo,
    fetchServiceRequestList,
    fetchServiceManagementLookups,
    fetchTechniciansList,
    history,
    setProgressBarLoading,
    targetNavCompany,
    ...props
}) => {
    const [companyName, setCompanyName] = useState();
    const [selectedUser, setSelectedUser] = useState(null);
    const [userAction, setUserAction] = useState('');

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        async function init() {
            await Promise.all([
                fetchServiceManagementLookups(activeNavCompany.id, 'Skilllevel'),
                fetchServiceManagementLookups(activeNavCompany.id, 'Skilltype')
            ].map(p => p.catch(err => err)));
        }

        if (activeNavCompany && activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        if (activeNavCompany && activeNavCompany.name) {
            if (userAction === 'create') {
                setPageTitle(activeNavCompany.name, 'Users & Permission');
            } else {
                setPageTitle(activeNavCompany.name, 'Users');
            }
        }
    }, [activeNavCompany, userAction]);

    useEffect(() => {
        const init = async () => {
            const { pathname } = history.location;

            if (!companyName) {
                setCompanyName(companyInfo.companyName);

                return;
            }

            const queryValuesString = queryString.stringify(queryValues);
            history.push(`${pathname}?${queryValuesString}`);
        };

        // If we have a companyId and no activeNavCompany that means we've (re)loaded, and
        // therefore need to reassemble the Company Overview page's data
        if (companyInfo.companyId && isEmpty(activeNavCompany)) init();
    }, [companyInfo]);

    useEffect(() => {
        async function init() {
        }

        init();
    }, [companyInfo.companyId]);

    const handleBackClick = () => {
        setUserAction('');
        setSelectedUser(null);
    };

    return (
        <BobPage>
            <div className={classes.UserPage}>
                <div className={classes.CompanyNamePanel}>
                    {companyName}
                </div>
                <div className={classes.HeaderPanel}>
                    {
                        selectedUser || userAction === 'create' ?
                            <span>
                                <span
                                    className={classes.BackIcon}
                                    aria-hidden="true"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() =>
                                        handleBackClick()
                                    }
                                >
                                    <i className="fas fa-chevron-left" />
                                </span>
                                { userAction === 'create' ? 'Users & Permission' : `${selectedUser.firstName} ${selectedUser.lastName}` }
                            </span>  : 'Users'
                    }
                </div>
                <div className={classes.DataPanel} />
                <div className={classes.TablePanel}>
                    {
                        selectedUser || userAction === 'create' ?
                            <UserDetails
                                isCreateUser={userAction === 'create' ? true : false}
                                selectedUser={selectedUser}
                                onCancelClick={() => handleBackClick()}
                            /> :
                            <TableContainer
                                userAction={userAction}
                                setUserAction={setUserAction}
                                setSelectedUser={setSelectedUser}
                            />
                    }
                </div>
            </div>
        </BobPage>
    );
};

UserPage.defaultProps = {
    companyInfo: {},
};

UserPage.propTypes = {
    companyInfo: object
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        companyInfo:      state.companyInfo
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...CoreActions,
    ...DashboardActions,
    ...jobActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserPage));
